import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AsyncButtonComponent } from './components/async-button/async-button.component';
import { SkyInputFormControlComponent } from './components/input-form-control/input-form-control.component';

import { SectionTileComponent } from './components/section-tile/section-tile.component';
import { SkySelectComponent } from './components/sky-select/sky-select.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { PaginationSizeComponent } from './components/table/pagination/pagination-size.component';
import { PaginationComponent } from './components/table/pagination/pagination.component';
import { TooltipBadgeComponent } from './components/tooltip-badge/tooltip-badge.component';
import { SkyTooltipDirective } from './directives/tooltip.directive';
import { MsToHMSDirective } from './directives/ms-to-hms.directive';
import { DateSelectComponent } from './components/date-select/date-select.component';
import { SkyTableComponent } from './components/table/table.component';
import { ListDataMobileContainerComponent } from './components/table/table-row-mobile.component';
import { TableFiltersContainerComponent } from './components/table/filters-container/filters-container.component';
import { BoolStatusDirective } from './directives/application-status.directive';
import { SkyFormControlCheckboxComponent } from './components/checkbox-form-control/checkbox-form-control.component';
import { SkyModalDefaultComponent } from './components/modal/modal-default.component';

const declarations: Array<any> = [
  SkyModalDefaultComponent,
  SvgIconComponent,
  SectionTileComponent,
  SkyTableComponent,
  SkyFormControlCheckboxComponent,
  TableFiltersContainerComponent,
  ListDataMobileContainerComponent,
  PaginationComponent,
  PaginationSizeComponent,
  SkySelectComponent,
  TooltipBadgeComponent,
  SkyInputFormControlComponent,
  SpinnerComponent,
  AsyncButtonComponent,
  DateSelectComponent,

  SkyTooltipDirective,
  BoolStatusDirective,
  MsToHMSDirective,
];

@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule],
  exports: [...declarations],
  declarations: [...declarations],
  providers: [],
})
export class SharedModule {}
